import { render } from "./SaleDetails.vue?vue&type=template&id=010d293c"
import script from "./SaleDetails.vue?vue&type=script&lang=js"
export * from "./SaleDetails.vue?vue&type=script&lang=js"
script.render = render

export default script